<template lang="pug">
  //- ユーザー選択
  app-modal(type="default", size="large", v-model="value.isOpen", data-testid="sel-user-modal")
    template(slot="title") ユーザーの選択

    .modal-layout
      .modal-side
        ul.nav.nav-tabs
          li.active
            a(data-toggle="tab" href="#tab-search") 検索
          li
            a(data-toggle="tab" href="#tab-group") 組織別
        .tab-content
          //- 検索
          .tab-pane#tab-search.active
            div(@keypress.enter.prevent="search()")
              .form-group
                label.control-label 氏名（漢字・よみがな）
                input.form-control(type='text' placeholder="前方一致で検索します" v-model="search_name" :maxlength="maxlengths.search_name", autocomplete="nope", data-testid="-input-name-search")
              .form-group
                label.control-label メールアドレス
                input.form-control(type='text' placeholder="前方一致で検索します" v-model="search_mail" :maxlength="maxlengths.search_corporate_name", autocomplete="nope")
              button.btn.btn-primary(type="button" @click.prevent="search", data-testid="-btn-search") 検索
          //- 組織別
          .tab-pane#tab-group
            ul.bcard-tree.bcard-side-tree
              li.list-group-item.fixed
                div.bcard-group-tree-item
                  div.bcard-group-tree-select-area(:class="[selectGroup.id === 0 ? 'selected' : '']")
                    a(href="#", @click.prevent="setGroupId(0)")
                      | (すべてのユーザー)
              group-tree-item(
                :onClickName="setGroupId",
                :selectedIds="[selectGroup.id > 0 ? selectGroup.id : 0]",
                :showRoot="false"
              )
              li.list-group-item.fixed
                div.bcard-group-tree-item
                  div.bcard-group-tree-select-area(:class="[selectGroup.id === -1 ? 'selected' : '']")
                    a(href="#", @click.prevent="setGroupId(-1)")
                      | (組織に属さない)

      .modal-layout-divider

      .modal-main
        .modal-list-target
          app-pagination(v-if="list.length > 0", :is-loading="loadingPagination", :pagination="pagination", :use-scroll-top="false", @change="getList")

          table.table.table-bordered.bcard-table
            thead
              tr
                th.bcard-table-td-chk
                  a(v-if="maxSelect === 100000", href='#', title='すべて追加', @click.prevent="apendAll")
                    i.fa.fa-fw.fa-angle-double-down
                th 名称

          loading(v-if="loading", :height="170")

          .table-responsive(v-else-if="list.length")
            table.table.table-bordered.bcard-table
              tbody
                tr(v-for="item in list", :key="item.id", :class="{active: isChecked(item.id)}")
                  td.bcard-table-td-chk
                    a(href='#', title='追加', @click.prevent="checkItem(item.id, true)")
                      i.fa.fa-fw.fa-arrow-down
                  td.bcard-table-td-fullname.bcard-ui-userdata
                    a(href='#', :title="item.full_name", @click.prevent="openModalProfile(item.id)")
                      i.fa.bcard-fa-person-private(v-if="item.openflag === app_flag.OFF")
                      |
                      | {{item.full_name}}
                  td.bcard-table-td-groups.bcard-ui-userdata(:title="item.dept") {{item.dept}}
                  td.bcard-table-td-post.bcard-ui-userdata(:title="item.post") {{item.post}}

          app-messages(
            v-if="list.length === 0",
            :alignCenter="true",
            :errorMessages="modalErrors",
            :defaultMessages="modalMessages"
          )

        .modal-list-divider

        .modal-list-selected
          table.table.table-bordered.bcard-table
            thead
              tr
                th.bcard-table-td-chk
                  a(href='#', title='すべての選択を解除', @click.prevent="checkAll(list, false)")
                    i.fa.fa-fw.fa-times
                th 名称
          .table-responsive
            table.table.table-bordered.bcard-table
              tbody
                tr(v-for="item in checkedItems", :key="item.id")
                  td.bcard-table-td-chk
                    a(href='#', title='解除', @click.prevent="checkItem(item.id, false)")
                      i.fa.fa-fw.fa-times
                  td.bcard-table-td-fullname.bcard-ui-userdata
                    a(href='#', :title="item.full_name", @click.prevent="openModalProfile(item.id)")
                      i.fa.bcard-fa-person-private(v-if="item.openflag === app_flag.OFF")
                      |
                      | {{item.full_name}}
                  td.bcard-table-td-groups.bcard-ui-userdata(:title="item.dept") {{item.dept}}
                  td.bcard-table-td-post.bcard-ui-userdata(:title="item.post") {{item.post}}

    template(slot="footer", slot-scope="{close}")
      button.btn.btn-primary(type="button", @click="selectAndClose" data-testid="-btn-ok") OK
      button.btn.btn-default(type="button", @click="close") キャンセル

    //- 余計なフォームデータが埋め込まれないように、使わないときは隠す
    modal-profile(v-if="modalProfile.isOpen", v-model="modalProfile")
</template>

<script>
import mixinList from '@/mixins/innerList'
import AppMessages from '@/components/molecules/AppMessages'
import AppModal from '@/components/templates/AppModal'
import DatePicker from '@/components/molecules/DatePicker'
import AppPagination from '@/components/molecules/AppPagination'
import ModalProfile from '@/components/organisms/ModalProfile'
import GroupTreeItem from '@/components/organisms/GroupTreeItem'
import Loading from '@/components/molecules/Loading'

export default {
  name: 'ModalSelUser',
  components: { AppMessages, AppModal, DatePicker, AppPagination, ModalProfile, GroupTreeItem, Loading },
  mixins: [ mixinList ],
  props: {
    /*
     * isOpen: 開閉状態
     * selectedIds: 選択IDs
     * selectedItems: 選択データ
     */
    value: {
      type: Object,
      required: true,
      default: function () {
        return {
          isOpen: false,
          selectedIds: [],
          selectedItems: []
        }
      }
    },
    maxSelect: {type: Number, required: false, default: 100000},
    getDels: {type: Boolean, required: false, default: false}
  },
  data: function () {
    return {
      loadingPagination: true,
      loading: false,
      modalErrors: [],
      modalMessages: [],
      search_name: '',
      search_mail: '',
      modalProfile: {
        isOpen: false,
        userId: null
      },
      selectGroup: {
        id: '',
        name: ''
      },
      maxlengths: {}
    }
  },
  watch: {
    'value.isOpen': function (newValue, oldValue) {
      // 開いたときの初期設定
      this.resetData()
      if (newValue && !oldValue) {
        // 選択済みアイテムがある場合、サーバーから情報を取得する
        if (this.value.selectedIds.length) {
          this._getInitList()
        }
      }
    }
  },
  created: function () {
    this.modalMessages = ['検索してください。']
    this.pagination.count = 0
    this.checkLimit = this.maxSelect
    this.maxlengths = this.loadMaxlengths('Users')
  },
  methods: {
    resetData: function () {
      this.loadingPagination = true
      this.list = []
      this.modalErrors = []
      this.modalMessages = []
      this.checkedIds = []
      this.search_name = ''
      this.search_mail = ''
    },
    search: function () {
      this.modalErrors = []
      this.modalMessages = []
      this.getList()
    },
    _getInitList: function (options) {
      const vm = this

      // API実行
      this.sendListRequest({
        repo: 'user',
        method: this.getDels ? 'postSearchAll' : 'postSearch',
        params: {
          ids: this.value.selectedIds
        },
        onSuccess: function (response) {
          vm.checkAll(vm.list, true)
          if (vm.list.length !== vm.value.selectedItems.length) {
            vm.modalMessages = ['取得できないデータがありました。']
            for (let item of vm.value.selectedItems) {
              if (!vm.isIncludes(vm.checkedIds, item.id)) {
                vm.list.push(item)
                vm.checkedIds.push(item.id)
              }
            }
          }
        }
      })
    },
    /**
     * 一覧取得処理
     * @param Object options
     *          page: ページ番号
     */
    getList: function (options) {
      const vm = this
      options = options || {}
      this.loading = true
      this.loadingPagination = !options.viaPagination

      // API実行
      this.sendListRequest({
        repo: 'user',
        method: this.getDels ? 'postSearchAll' : 'postSearch',
        params: {
          page: options.page || 1,
          name: this.search_name,
          mail: this.search_mail
        },
        silent: true, // #476 検索しなおし、ページ切替のときに選択済みのIDをリセットしないようにする
        onSuccess: function (response) {
          if (vm.list.length === 0) {
            vm.modalMessages = ['データがありません。検索条件を変えて再検索してください。']
          }
        },
        finally: function () {
          vm.loading = false
          vm.loadingPagination = false
        }
      })
    },
    selectAndClose: function () {
      this.$emit('input', {
        isOpen: false,
        selectedIds: this.checkedIds,
        selectedItems: this.checkedItems
      })
    },
    openModalProfile: function (userId) {
      this.modalProfile.userId = userId
      this.modalProfile.isOpen = true
    },
    /**
     * 現在表示中の一覧を選択中一覧に追加する
     */
    apendAll: function () {
      let list = []
      for (let item of this.checkedItems) {
        if (list.indexOf(item) < 0) {
          list.push(item)
        }
      }
      for (let item of this.list) {
        if (list.indexOf(item) < 0) {
          list.push(item)
        }
      }
      this.checkAll(list, true)
    },
    // ツリーコンポーネントに渡して実行させる
    // 所属組織IDを更新
    setGroupId: function (group) {
      if (typeof group === 'object') {
        this.selectGroup.id = group.id
        this.selectGroup.name = group.name
      }
      else {
        this.selectGroup.id = group
        this.selectGroup.name = ''
      }
      this.getGroupList({page: 1})
    },
    /**
     * 一覧取得処理（組織別）
     * @param Object options
     *          page: ページ番号
     */
    getGroupList: function (options) {
      const vm = this
      options = options || {}
      this.loading = true
      this.loadingPagination = !options.viaPagination
      // API実行
      this.sendListRequest({
        repo: 'user',
        method: 'getList',
        params: {
          page: options.page || 1,
          group: this.selectGroup.id,
          only_enable: '1' // ステータス＝'有効'のみ取得
        },
        silent: true, // #476 検索しなおし、ページ切替のときに選択済みのIDをリセットしないようにする
        onSuccess: function (response) {
          if (vm.list.length === 0) {
            vm.modalMessages = ['データがありません。検索条件を変えて再検索してください。']
          }
        },
        finally: function () {
          vm.loading = false
          vm.loadingPagination = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 左エリア
.bcard .modal .modal-side {
  padding: 0;

  .nav.nav-tabs {
    padding: 15px 15px 0 15px;
  }

  .tab-content {
    padding: 15px;

    .bcard-tree {
      max-height: 404px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalSelUser.vue